module.exports = __webpack_public_path__ + "static/media/nf.8f8df7a2.svg";